const initialState = {}

const tables = (state = initialState, { name, type, ...action }) => {
  switch (type) {
    case 'INIT_TABLE':
    case 'SET_COLLAPSED_CONTENT':
    case 'SET_LOADING_TABLE':
    case 'SET_FILTER':
    case 'SET_HEADER':
    case 'SET_LIMIT':
    case 'SET_COUNT':
    case 'SET_CONTENT':
    case 'SET_PAGE':
    case 'SET_DISPLAY_ARCHIVED':
    case 'SET_VISIBLE_COLUMN':
    case 'SET_SORT_BY':
    case 'SET_RESOURCES_SELECTION':
      return { ...state, [name]: { ...state[name], ...action } }
    case 'DESTROY_TABLE':
      delete state[name]
      return { ...state }
    case 'SET_LOGGED_OUT':
      return { ...initialState }
    default:
      return state
  }
}

export default tables
